import React from 'react';

import {
	questionArea,
	questionSection,
	questionCount,
	questionTitle,
	questionText,
	answerSection,
	points
} from "../teaquiz.module.css"


const SingleSelect = (props) => (
	<>
		<div className={questionArea}>
			<h1 className={questionTitle}>{props.title}</h1>
			<div className={questionSection}>
				<div className={questionCount}>
					<span>Question {props.currentQuestion + 1}</span>/{props.questions.length}
				</div>
				<div className={points}>For {props.dificulty} points
					<span>Current Score: {props.score}</span>
				</div>
				<div className={questionText}>{props.question}</div>
			</div>
			<div className={answerSection}>
				{props.answersList.map((x) => (
					<button  key={x} onClick={() => props.handleAnswerOptionClick(x)}>{x}</button>
				))}
			</div>
		</div>
		<img src={props.image} alt={props.question} />
	</>
)
export default SingleSelect